import React, { useState, createContext } from 'react';

const userDataCtx = createContext({ data: {}, setData: (key: string, value: any) => { }, validationFlags: new Map<string, boolean>(), setValidationFlags: (err: Map<string, boolean>) => {} });

/** 
* Creates a object to store
* application specific data
*/
function useAppData() {
    const [data, setAppData] = useState({});
    const setData = (key: string, value: any) => {
        setAppData({
            ...data,
            [key]: value
        })
    };

    const initData = (baseData: any) => setAppData({...baseData});

    const [validationFlags, setAppDataValidationFlags] = useState<Map<string,boolean>>(new Map<string, boolean>());

    const setValidationFlags =(err: Map<string, boolean>) => {
        setAppDataValidationFlags(err);
    }
    return {
        data,
        setData,
        initData,
        validationFlags,
        setValidationFlags
    }
}

export { userDataCtx, useAppData };
